export default {
  namespaced: true,

  state: {
    status: false,
    mensagens: [],
  },

  getters: {
    STATUS_CONEXAO(state) {
      return state.status;
    },
    MENSAGENS(state) {
      return state.mensagens;
    },
  },

  mutations: {
    SET_STATUS_CONEXAO(state, payload) {
      state.status = payload;
    },
    PUSH_MENSAGENS(state, payload) {
      state.mensagens.unshift({
        data: new Date(),
        mensagem: payload,
      });
    },
    REMOVE_MENSAGEM(state, payload) {
      state.mensagens.splice(payload, 1);
    },
    LIMPAR_TODAS_MENSAGENS(state) {
      state.mensagens = [];
    },
  },
};
